export default (props, vars) => props?.['name'] === 'open_in_new';
